/**
 * ChatEntry — `/chat/open`, the target of the home «Чат с Calestea» button.
 * Asks the server for the caller's conversations and replaces itself with the latest one
 * (whichever chart it is about), or with a new conversation about «Я» when there is none yet.
 * A failed read is not a dead end: the chat screen reports its own network errors.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CosmosBackdrop } from '../../components/brand/CosmosBackdrop.js';
import { OrbitalLoader } from '../../components/brand/OrbitalLoader.js';
import { fetchAllChatThreads } from '../../hooks/useChatThreads.js';
import { newChatHref, threadHref } from '../../lib/chat-links.js';
import { useAuth } from '../../store/auth.js';
import styles from './AstrologerChat.module.css';

export function ChatEntry(): JSX.Element {
  const navigate = useNavigate();
  const jwt = useAuth((s) => s.jwt);

  useEffect(() => {
    if (!jwt) return;
    let cancelled = false;
    // Always read fresh: a cached list could send the user to a conversation that is no longer the latest.
    fetchAllChatThreads(jwt)
      .then((threads) => threads[0])
      .catch(() => undefined)
      .then((latest) => {
        if (cancelled) return;
        void navigate(latest ? threadHref(latest.id) : newChatHref({ id: '', isSelf: true }), { replace: true });
      });
    return () => { cancelled = true; };
  }, [jwt, navigate]);

  return (
    <div className={styles.root} data-testid="chat-entry">
      <CosmosBackdrop />
      <div className={styles.center}>
        <OrbitalLoader sigilSize={120} />
      </div>
    </div>
  );
}
